module.exports = __webpack_public_path__ + "img/meme_32.aff8c7e3.jpg";